module.exports = __webpack_public_path__ + "static/corey-2c2f0d4a7d27200fc6c42c1609c8384c.gif";